const varReplace = (string, ...values) => {
  values.forEach(value => {
    string = string.replace(/\${\w+}/, value)
  })
  return string
}

export default varReplace